import { dateToUTCString } from "@focus/utils";
export const dateToUntilSeconds = (dateInUnix) => {
    const stringDate = dateToUTCString(dateInUnix);
    return stringDate.substring(0, stringDate.length - 4);
};
export const dateToUntilMinutes = (dateInUnix) => {
    const stringDate = dateToUTCString(dateInUnix);
    return stringDate.substring(0, stringDate.length - 7);
};
//# sourceMappingURL=dateStringUtils.js.map